import type { LeaderboardEntry } from './types';

/**
 * PLACEHOLDER rows, taken from the Figma frame's mock board (4541:7068) so the
 * section renders its real layout. Replace once the data source is planned.
 *
 * `country` only feeds the podium flags — the table in this design has none.
 */
export const SAMPLE_LEADERBOARD: LeaderboardEntry[] = [
  { rank: 1, country: 'de', name: 'Thomas', points: 369, winrate: 75.9, trades: 1536, profitFactor: 2.58 },
  { rank: 2, country: 'gb', name: 'Sidney S.', points: 279, winrate: 86.8, trades: 726, profitFactor: 2.87 },
  { rank: 3, country: 'it', name: 'Daniel S.', points: 265, winrate: 73.7, trades: 430, profitFactor: 1.97 },
  { rank: 4, country: 'ae', name: 'Anika', points: 211, winrate: 64.9, trades: 1855, profitFactor: 1.28 },
  { rank: 5, country: 'es', name: 'RSR', points: 187, winrate: 62.0, trades: 50, profitFactor: 3.07 },
  { rank: 6, country: 'fr', name: 'S.', points: 184, winrate: 46.1, trades: 26, profitFactor: 4.65 },
  { rank: 7, country: 'nl', name: 'Chris T.', points: 161, winrate: 55.3, trades: 38, profitFactor: 3.0 },
  { rank: 8, country: 'pt', name: 'seancelik', points: 160, winrate: 58.8, trades: 131, profitFactor: 2.09 },
  { rank: 9, country: 'pl', name: 'Douglas A.', points: 144, winrate: 26.5, trades: 34, profitFactor: 3.18 },
  { rank: 10, country: 'br', name: 'Mohan D.', points: 138, winrate: 60.5, trades: 903, profitFactor: 1.49 },
  { rank: 11, country: 'us', name: 'Ef:KO', points: 71, winrate: 49.3, trades: 229, profitFactor: 1.14 },
  { rank: 12, country: 'ca', name: 'brian L.', points: 64, winrate: 50.0, trades: 4, profitFactor: 8.4 },
];
